"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var strings = {
  prefixAgo: 'fyrir',
  prefixFromNow: 'eftir',
  suffixAgo: 'síðan',
  suffixFromNow: null,
  seconds: 'minna en mínútu',
  minute: 'mínútu',
  minutes: '%d mínútum',
  hour: 'klukkutíma',
  hours: 'um %d klukkutímum',
  day: 'degi',
  days: '%d dögum',
  month: 'mánuði',
  months: '%d mánuðum',
  year: 'ári',
  years: '%d árum',
  wordSeparator: ' '
};
var _default = strings;
exports["default"] = _default;